/**
 * Colores del tema TAL COMO LOS CALCULA la app nativa, para que el preview coincida con el teléfono.
 *
 * La app no usa `colorTema` tal cual: con él genera un `ColorScheme` Material 3 (MaterialKolor,
 * `seedColorScheme` en `seguridad-boton-nativo/.../ui/theme/ColorSchemes.kt`, estilo TonalSpot) y los
 * templates pintan con sus roles. P.ej. el seed naranja `#FB972E` da `primary = #87521c` (marrón).
 * Esta es la librería oficial de Google del mismo algoritmo (HCT); verificado contra la app con 8
 * seeds (2026-10-20): mismos hex. Solo modo claro, que es el que usa la botonera.
 */
import {
  argbFromHex,
  hexFromArgb,
  Hct,
  MaterialDynamicColors,
  SchemeTonalSpot,
} from '@material/material-color-utilities';

/** Seed por defecto de la app (`GpeSeed`) cuando el cliente no tiene `colorTema`. */
const SEED_DEFECTO = '#FB972E';

const cache = new Map<string, { primary: string; error: string }>();

function esquema(seed?: string | null): { primary: string; error: string } {
  const hex = /^#[0-9a-f]{6}$/i.test(seed ?? '') ? seed! : SEED_DEFECTO;
  let c = cache.get(hex);
  if (!c) {
    const s = new SchemeTonalSpot(Hct.fromInt(argbFromHex(hex)), false, 0);
    c = {
      primary: hexFromArgb(MaterialDynamicColors.primary.getArgb(s)),
      error: hexFromArgb(MaterialDynamicColors.error.getArgb(s)),
    };
    cache.set(hex, c);
  }
  return c;
}

/** `colorScheme.primary` de la app para ese `colorTema`: el "color del tema" que se ve en el teléfono. */
export function primarioApp(colorTema?: string | null): string {
  return esquema(colorTema).primary;
}

/** `colorScheme.error` de la app: el fondo de los botones sin color propio (`PanicButton`). */
export function errorApp(colorTema?: string | null): string {
  return esquema(colorTema).error;
}
